export const APP_NAME = 'StampImg';
export const ROUTE_PREFIX = '/pwa-stampimg';
